'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _OMButtonWithPreloader = require('./OMButtonWithPreloader.scss');var _OMButtonWithPreloader2 = _interopRequireDefault(_OMButtonWithPreloader);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var OMButtonWithPreloader = function OMButtonWithPreloader(properties) {return (
    _react2.default.createElement('button', {
        type: properties.type || 'submit',
        className: (0, _classnames2.default)('btn btn-primary', _OMButtonWithPreloader2.default.default, _OMButtonWithPreloader2.default[properties.className]),
        onClick: properties.onClick,
        disabled: properties.showPreloader,
        id: properties.id },


      properties.showPreloader ?
      _react2.default.createElement('span', { className: 'icon icon-om-spinner om-pulse' }) :
      properties.innerText));};exports.default =



OMButtonWithPreloader;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMButtonWithPreloader/OMButtonWithPreloader.js
// module id = 376
// module chunks = 0